import React, { Component } from 'react';
import './Communication.css';
import data from '../../data/Communication.js';

import Layout from '../../components/Layout/Layout';
import Icon from '../../components/Icon/Icon';
import Intro from '../../components/Intro/Intro';

import EmailAndCalendars from './EmailAndCalendars/EmailAndCalendars';
import EmailMobile from './EmailMobile/EmailMobile';
import HowTo from './HowTo/HowTo';
import Messaging from './Messaging/Messaging';
import PhonePark from './PhonePark/PhonePark';
import Phones from './Phones/Phones';
import PhoneSystem from './PhoneSystem/PhoneSystem';

class Communication extends Component {
	render() {
		return (
			<Layout colors={ data.colors }>
				<div className="Communication">
					<Intro>
						<Icon icon="communication.intro" />
						<div className="intro-title">
							<h1>Collaborate <span>&</span> Listen</h1>
							<p>
								You probably already know that good communication is important to successful teamwork (some of us even have degrees in it!). Because so much of our teamwork happens virtually, it's absolutely vital to IDSI's success that we're all available and responsive via the communication channels covered in this section.
							</p>
						</div>
					</Intro>
					
					<EmailAndCalendars />
					<HowTo slides={ data.howTo } />
					<EmailMobile />
					<Messaging />
					<Phones docs={data.docs } />
					<PhoneSystem />
					<PhonePark />
				</div>
			</Layout>
		);
	}
};

export default Communication;



// WEBPACK FOOTER //
// ./src/pages/Communication/Communication.js